/**
 * @module store/header/actions
 */
import { createFormUploadObject } from '/src/common/general-utils';
export async function submitSupport(ctx, { payload, file }) {
  let supportRequest = payload;
  let headers = [];
  if (file) {
    supportRequest = createFormUploadObject(payload, [file]);
    headers = { 'Content-Type': 'multipart/form-data' };
  }

  return await this.$axios.$post(`/api/support-config/generate`, supportRequest, headers).then((result) => result.data);
}

export async function switchUser(ctx, delegateId) {
  return await this.$axios.$post(`/api/user-delegates/${delegateId}/switch`);
}

export async function getActiveDelegateCount({ commit, rootGetters }) {
  try {
    if (!rootGetters.userID) {
      this.$toast.error(this.vueApp.$nuxt.$i18n.global.t('common.delegate.no_current_user'));
      return;
    }
    const count = await this.$axios.$get(`/api/user-delegates/count/${rootGetters.userID}`);
    commit('setDelegateCount', count, { root: true });
  } catch (error) {
    this.$toast.error(this.$errorFromResponse('common.delegate.delegate_count_fetching_error', error));
    commit('setDelegateCount', 0, { root: true });
  }
}
